
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 27","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.004 16.313v9.23M8.395 25.541h9.229M6.55 10.776a5.538 5.538 0 01-5.538-5.538V3.392h6.46v7.384H6.55zM19.474 10.776a5.537 5.537 0 005.537-5.538V3.392h-6.46v7.384h.923z","stroke":"#E6E7E9","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M18.548 10.775a5.538 5.538 0 11-11.075 0v-9.23h11.075v9.23z","stroke":"#E6E7E9","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    